import React from 'react';
import api from 'api';
import initStore from './initStore';
import { getLanguageState } from '.';

const isServer = typeof window === 'undefined';
const __NEXT_REDUX_STORE__ = '__NEXT_REDUX_STORE__';

const getOrCreateStore = (messages, serverConfig, headers, initialState) => {
  // Always make a new store if server, otherwise state is shared between requests
  if (isServer) {
    return initStore(messages, serverConfig, headers, initialState);
  }

  // Store in global variable if client
  if (!window[__NEXT_REDUX_STORE__]) {
    window[__NEXT_REDUX_STORE__] = initStore(
      messages,
      serverConfig,
      headers,
      initialState
    );
  }
  return window[__NEXT_REDUX_STORE__];
};

const withReduxStore = (App) => {
  return class Redux extends React.Component {
    static async getInitialProps(appContext) {
      try {
        let reduxStore;
        if (!isServer && window[__NEXT_REDUX_STORE__]) {
          reduxStore = window[__NEXT_REDUX_STORE__];
        } else {
          const headers = appContext.ctx.req
            ? appContext.ctx.req.headers
            : null;
          let Cookie =
            headers && headers.cookie ? { Cookie: headers.cookie } : {};

          // server config
          let response = await api.get('/admin/server-config', {
            headers: Cookie
          });
          const serverConfig = response.data.data;

          // messages
          const language = getLanguageState({
            headers,
            serverConfig,
            serverState: null
          });

          response = await api.get(
            `/admin/server-config/locales?language=${language}`,
            { headers: Cookie }
          );
          const { messages } = response.data;

          reduxStore = getOrCreateStore(messages, serverConfig, headers);
        }

        // Provide the store to getInitialProps of pages
        appContext.ctx.reduxStore = reduxStore;

        let appProps = {};
        if (App.getInitialProps) {
          appProps = await App.getInitialProps(appContext);
        }

        return { ...appProps, initialReduxState: reduxStore.getState() };
      } catch (err) {
        // error in reaching the server to get serverConfig
        if (appContext.ctx.res) appContext.ctx.res.statusCode = 500;

        const reduxStore = getOrCreateStore();
        return { isError: true, initialReduxState: reduxStore.getState() };
      }
    }

    constructor(props) {
      super(props);
      this.isError = props.isError || false;
      this.reduxStore = getOrCreateStore(
        null,
        null,
        null,
        props.initialReduxState
      );
    }

    render() {
      return (
        <App
          {...this.props}
          isAppError={this.isError}
          reduxStore={this.reduxStore}
        />
      );
    }
  };
};

export default withReduxStore;
